/**
 * Reports module configuration
 * ─────────────────────────────
 * Add, remove, or reorder tabs here to control available reports.
 */

export const REPORT_TABS = [
   { id: 'category-fund',  label: 'Category Fund'  },
   { id: 'account-ledger', label: 'Ledger Balance' },
   { id: 'trial-balance',  label: 'Trial Balance'  },
  { id: 'income-expenditure', label: 'Income & Expenditure' },
  { id: 'balance-sheet',  label: 'Balance Sheet'  },  
  { id: 'day-book',       label: 'Day Book'        },
  { id: 'cash-book',      label: 'Cash Book'       },
  { id: 'bank-book',      label: 'Bank Book'       },
  { id: 'gold-register',    label: 'Gold Register'    },
  { id: 'item-register',    label: 'Item Register'    },
  { id: 'bhandar-register', label: 'Bhandar Register' },
];

/** Reports that use a date range (From → To) */
export const DATE_RANGE_TABS = ['balance-sheet', 'trial-balance', 'category-fund', 'cash-book', 'bank-book', 'gold-register', 'item-register', 'bhandar-register', 'income-expenditure', 'day-book'];

/** Reports that use a single "As on Date" */
export const AS_ON_DATE_TABS = [];

/** Reports that use a single date */
export const SINGLE_DATE_TABS = [];

/** Account Ledger manages its own data fetch — hide shared filters + run/pdf buttons */
export const ACCOUNT_LEDGER_TAB = 'account-ledger';
